<div class="flex items-start">
  <div class="mr-3 mt-1" *ngIf="message.severity">
    <app-svg-viewer [svg]="loadIcon(message.severity)!"></app-svg-viewer>
  </div>
  <div class="flex-1">
    <h3 *ngIf="message.summary" class="text-lg font-semibold mb-1">{{ message.summary }}</h3>
    <h3 *ngIf="!message.summary && message.severity" class="text-lg font-semibold mb-1">
      {{ resource.generic[message.severity] }}
    </h3>
    <p class="text-sm m-0" *ngIf="message.detail">{{ message.detail }}</p>
  </div>
</div>
